import React from 'react';

import DsLabel from '../label/index';

const LoadingLabel = ({ children }) => (
  <DsLabel icon="logo-sm" className="text-lg uppercase text-primary" iconClassName="animate-spin-slow">
    {children}
  </DsLabel>
);

export default LoadingLabel;
